import { render, staticRenderFns } from "./starDisplay.vue?vue&type=template&id=308cfb03&"
import script from "./starDisplay.vue?vue&type=script&lang=js&"
export * from "./starDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('308cfb03')) {
      api.createRecord('308cfb03', component.options)
    } else {
      api.reload('308cfb03', component.options)
    }
    module.hot.accept("./starDisplay.vue?vue&type=template&id=308cfb03&", function () {
      api.rerender('308cfb03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2LXIs7RWkkWWf/JS/starDisplay.vue"
export default component.exports